import React from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'



const FileManagerBlankPage: React.FC = () => {
  return (
    <>
      <PageTitle>Página em Branco</PageTitle>
      <div className='card'>
        <div className='card-body'>
          <p className='text-muted'>Esta é uma página em branco, pronta para conteúdo customizado.</p>
        </div>
      </div>
    </>
  )
}

export default FileManagerBlankPage
